import { render, staticRenderFns } from "./EdicaoVinculacoes.vue?vue&type=template&id=19344a5e&scoped=true&"
import script from "./EdicaoVinculacoes.vue?vue&type=script&lang=js&"
export * from "./EdicaoVinculacoes.vue?vue&type=script&lang=js&"
import style0 from "./EdicaoVinculacoes.vue?vue&type=style&index=0&id=19344a5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19344a5e",
  null
  
)

export default component.exports